<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3">
        <b>Dados do Equipamento</b>
      </div>
      <div class="row g-3">
        <div
          class="col-md-6"
          :class="{
            'field-required': validation.objDTO.Veiculo.Modelo.$invalid,
          }"
        >
          <!--Tipo (obrigatório); -->
          <label for="tipoEquipamento" class="form-label">Tipo</label>
          <InputText
            id="tipoEquipamento"
            v-model="objDTO.Veiculo.Modelo"
            class="form-control"
          />
        </div>
        <div
          class="col-md-6"
          :class="{
            'field-required': validation.objDTO.ProcessoGDM.Marca.$invalid,
          }"
        >
          <!--Marca (obrigatório); -->
          <label for="marcaEquipamento" class="form-label">Marca</label>
          <InputText
            id="marcaEquipamento"
            v-model="objDTO.ProcessoGDM.Marca"
            class="form-control"
          />
        </div>
        <div
          class="col-md-6"
          :class="{
            'field-required': validation.objDTO.ProcessoGDM.Modelo.$invalid,
          }"
        >
          <!--Modelo (obrigatório); -->
          <label for="modeloEquipamento" class="form-label">Modelo</label>
          <InputText
            id="modeloEquipamento"
            v-model="objDTO.ProcessoGDM.Modelo"
            class="form-control"
          />
        </div>
        <div
          class="col-md-6"
          :class="{
            'field-required': validation.objDTO.Veiculo.NrChassis.$invalid,
          }"
        >
          <!--Chassi (obrigatório); -->
          <label for="chassiEquipamento" class="form-label">Chassi</label>
          <InputText
            id="chassiEquipamento"
            v-model="objDTO.Veiculo.NrChassis"
            class="form-control"
          />
        </div>
        <div
          class="col-md-6"
          :class="{
            'field-required': validation.objDTO.Veiculo.ModeloAno.$invalid,
          }"
        >
          <!--Ano Fabricação (obrigatório); -->
          <label for="anoFabricacao" class="form-label">Ano Fabricação</label>
          <Dropdown
            id="anoFabricacao"
            v-model="objDTO.Veiculo.ModeloAno"
            :options="pastYearsAsList"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione o ano"
            :filter="true"
            :showClear="true"
            class="form-control"
          />
        </div>
        <div class="col-md-6">
          <!--Estimativa de Prejuízo (facultativo).  -->
          <label for="estimativaPrejuizoEquipamento" class="form-label"
            >Estimativa de Prejuízo</label
          >
          <InputNumber
            id="estimativaPrejuizoEquipamento"
            v-model="objDTO.Veiculo.ValorEstimadoReparacao"
            :minFractionDigits="2"
            :maxFractionDigits="2"
            mode="currency"
            currency="BRL"
            class="form-control p-0"
            locale="pt-BR"
          />
        </div>
      </div>
    </div>
  </div>
  <!--Tipo (obrigatório);-->
  <!--Marca (obrigatório);-->
  <!--Modelo (obrigatório);-->
  <!--Chassi / Série (obrigatório);-->
  <!--Ano Fabricação (obrigatório);-->
  <!--Estimativa de Prejuízo (facultativo).  -->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    validation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pastYearsAsList: this.getYearsToDate(),
    };
  },
  computed: {
    ...mapGetters({ objDTO: 'getObjDTO' }),
  },
  methods: {
    getYearsToDate() {
      const yearsToDate = [];
      const currentYear = new Date().getFullYear();
      for (let i = 1950; i <= currentYear; i++) {
        yearsToDate.push({
          value: i,
          label: i,
        });
      }
      return yearsToDate;
    },
  },
};
</script>

<style></style>
